import { useParams } from '@tanstack/react-router'

import { SessionDetailsScreen } from '@/screens/SessionDetailsScreen'
import { ServicePageShell } from '@/screens/ServicePageShell'
import { formatRelativeDateTime } from '@/lib/relativeDateTime'
import { useSessionDetails } from '@/screens/useSessionDetails'

export function SessionDetailsScreenContainer() {
  const sessionId = useParams({
    from: '/sessions/$id',
    select: (p) => p.id,
  })

  const details = useSessionDetails(sessionId)

  if (details.kind === 'loading') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-4xl mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Remote session details</h1>
          <p className="text-sm text-slate-600">Loading session…</p>
        </main>
      </div>
    )
  }

  if (details.kind === 'error') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-4xl mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Remote session details</h1>
          <p className="text-sm text-slate-600">
            Unable to load session details right now.
          </p>
        </main>
      </div>
    )
  }

  if (details.kind === 'not_found') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-4xl mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Remote session details</h1>
          <p className="text-sm text-slate-600">
            Remote session not found. Check the link or return to the sessions list.
          </p>
        </main>
      </div>
    )
  }

  const displayId = details.screenProps.publicId ?? details.screenProps.serviceId

  return (
    <ServicePageShell
      serviceTypeLabel={details.screenProps.serviceTypeLabel ?? 'TeamViewer Session'}
      serviceId={displayId}
      customerName={details.screenProps.customerName}
      customerId={details.screenProps.customerId}
      customerPublicId={details.screenProps.customerPublicId}
      scheduledAtLabel={
        details.screenProps.isWholeDay
          ? `${formatRelativeDateTime(details.screenProps.startTime, { includeTime: false })} · No Time`
          : formatRelativeDateTime(details.screenProps.startTime)
      }
      initialIssue={details.screenProps.issueSummary}
      activeTab="details"
      basePath="/sessions/$id"
      currentStatus={details.screenProps.status}
      statusChanges={details.screenProps.statusChanges}
      getAuthorDisplayName={details.screenProps.getAuthorDisplayName}
    >
      <SessionDetailsScreen {...details.screenProps} showHeader={false} />
    </ServicePageShell>
  )
}
